const initialState = {
    isOpen: false,
};
const bottom_sheet = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_BOTTOM_SHEET':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default bottom_sheet;
